import { useMutationUpdateUser, usersQueryKey } from "@apis:user/user";
import { SuperInput } from "@components:SuperInput/SuperInput";
import { useInvalidateQueries } from "@hooks:useInvalidateQueries";
import { useUser } from "@libs:react-query-auth";
import { Box, Button } from "@mui/material";
import Typography from "@mui/material/Typography";
import { Header } from "@pages:settings/Header";
import { useToasterStoreActions } from "@stores:global";
import { useState } from "react";

import { UsersUpdateSchema } from "@:openapi";

export const Profile = () => {
  const invalidateQueries = useInvalidateQueries();
  const toastActions = useToasterStoreActions();
  const user = useUser().data;
  const [email, setEmail] = useState(user!.email);
  const [name, setName] = useState(user!.name);

  const [password, setPassword] = useState("");

  const updateMeMutation = useMutationUpdateUser({
    onSettled: async () => {
      setPassword("");
      await invalidateQueries.run([
        {
          queryKey: usersQueryKey.me.queryKey,
        },
      ]);
    },
    onError: () => {
      toastActions.setToaster({
        open: true,
        message: "Failed to update profile",
        variant: "error",
      });
    },
    onSuccess: () => {
      toastActions.setToaster({
        open: true,
        message: "Profile updated",
        variant: "success",
      });
    },
  });

  const handleUpdateMe = async (params: UsersUpdateSchema) => {
    await updateMeMutation.mutateAsync({
      id: user!.id,
      ...params,
    });
  };

  return (
    <Box
      className="Settings__Profile__Details"
      sx={{
        width: "100%",
      }}
    >
      <Header />
      <Box
        sx={{
          mx: "auto",
          maxWidth: "30rem",
        }}
      >
        <Box className={"Settings__Profile__Details__Basics"}>
          <Typography
            sx={{
              marginTop: "2rem",
              fontSize: "1.2rem",
              fontWeight: "bold",
            }}
          >
            General
          </Typography>

          <Box
            sx={{
              marginTop: "1rem",
            }}
          >
            <SuperInput.TextField
              label="Full name"
              value={name}
              onChange={(e) => setName(e.target.value)}
            />

            <SuperInput.TextField
              sx={{
                marginTop: "1rem",
              }}
              label="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />

            <Button
              variant="contained"
              sx={{
                marginTop: "1rem",
              }}
              onClick={async () => {
                await handleUpdateMe({
                  name,
                  email,
                });
              }}
            >
              Save
            </Button>
          </Box>

          <Box
            className={"Settings__Profile__Details__Password"}
            sx={{
              mt: "4rem",
            }}
          >
            <Typography
              sx={{
                marginTop: "2rem",
                fontSize: "1.2rem",
                fontWeight: "bold",
              }}
            >
              Change password
            </Typography>

            <Box
              sx={{
                marginTop: "1rem",
              }}
            >
              <SuperInput.TextField
                sx={{
                  marginTop: "1rem",
                }}
                label="New password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                type="password"
              />

              <Button
                variant="contained"
                sx={{
                  marginTop: "1rem",
                }}
                onClick={async () => {
                  await handleUpdateMe({
                    password,
                  });
                }}
              >
                Save
              </Button>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};
